import { useQuery } from "react-query";
import { getDistinctEntity } from "../../../../../actions/Utilities/Entity";

export const useDistinctEntity = () => {
  return useQuery("GetDistinctEntity", getDistinctEntity, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
